{
  "Clear search": "مسح البحث"
}